import Client from "@/repositories/Client/AxiosClient.js"

const resource = `/api/agents/assigned`

export default {
  list(agentId) {
    return Client.get(`${resource}/${agentId}`)
  },
  create(assignAppliancePm) {
    return Client.post(`${resource}`, assignAppliancePm)
  },
  delete(assignedApplianceId) {
    return Client.delete(`${resource}/${assignedApplianceId}`)
  },
}
